import { render, staticRenderFns } from "./FPriceDiff.vue?vue&type=template&id=0cffef52&"
import script from "./FPriceDiff.vue?vue&type=script&lang=js&"
export * from "./FPriceDiff.vue?vue&type=script&lang=js&"
import style0 from "./FPriceDiff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports